import useAppQuery from '../useAppQuery';
import API from '../../services/API';

const useGetHostfullyDevicesUrl = () => {
  const { refetch: getHostfullyDevicesUrl } = useAppQuery({
    queryKey: ['hostfullyDevicesUrl'],
    queryFn: async () => {
      const response = await API.get<{ url: string }>(
        '/api/identity/internal/hostfully-devices/access-url',
      );
      return response.data;
    },
    enabled: false,
  });

  return { getHostfullyDevicesUrl };
};

export default useGetHostfullyDevicesUrl;
